import { UiVaultConfig } from 'src/@types/vaults';
import { VaultPerformanceV2 } from './VaultPerformanceV2';

import { NotionalGrowthStrategyAlert } from '../VaultGraphs';
import { SpotMarketConfig } from '@velocity-exchange/sdk';
import { UIMarket } from '@velocity-exchange/common';

export const VaultPerformance = (props: { uiVaultConfig: UiVaultConfig }) => {
	return (
		<div className="flex w-full flex-col gap-6">
			{props.uiVaultConfig.isNotionalGrowthStrategy && (
				<NotionalGrowthStrategyAlert />
			)}

			<VaultPerformanceV2
				vaultPubkey={props.uiVaultConfig.vaultPubkeyString}
				depositAssetConfig={
					UIMarket.createSpotMarket(props.uiVaultConfig.depositAsset)
						.market as SpotMarketConfig
				}
			/>
		</div>
	);
};
